export default __webpack_public_path__ + "b8e1bcb825b7a79a586ce90396b3f1b0.png";